// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"150":"2f2d2e666562b089","1342":"7a4ceaa5ae463d00","2020":"9970c1ac8054a5ba"}[chunkId] + ".js";
};